export const STORE = {
  name: "Promax Tintas",
  slogan: "Expertos en colores",
  legacyName: "Pinturería Yegros",
  tagline: "Promax Tintas, expertos en colores. Tu distribuidor autorizado Sherwin-Williams en Hernandarias.",
  facebook: "https://www.facebook.com/profile.php?id=61592786493738",
  address: "Av. Fulgencio Yegros esq. Mariscal López",
  city: "Hernandarias, Alto Paraná — Paraguay",
  hours: "Lun a Vie 07:30–18:00 · Sáb 07:30–12:30",
  // Número de WhatsApp de la tienda (formato internacional, sin +). Editá aquí.
  whatsapp: "595994372402",
  phoneDisplay: "+595 994 372 402",
};

export const SECTORS = [
  { key: "inmobiliario", label: "Inmobiliario", desc: "Látex, esmaltes e impermeabilizantes para tu hogar y obra.",
    color: "#0067B1", bg: "#EFF6FF", text: "#1D4ED8", border: "#BFDBFE" },
  { key: "automotivo", label: "Automotivo", desc: "Bases, barnices 2K, masillas y todo para chapería y pintura.",
    color: "#E02424", bg: "#FEF2F2", text: "#B91C1C", border: "#FECACA" },
  { key: "industrial", label: "Industrial", desc: "Epoxis, anticorrosivos y recubrimientos de alto tráfico.",
    color: "#B45309", bg: "#FFFBEB", text: "#B45309", border: "#FDE68A" },
  { key: "accesorios", label: "Accesorios e Insumos", desc: "Lijas, ceras, masillas, pistolas y materiales de terminación.",
    color: "#15803D", bg: "#F0FDF4", text: "#15803D", border: "#BBF7D0" },
];

export const sectorMeta = (key) => SECTORS.find((s) => s.key === key) || SECTORS[0];

export const formatGs = (n) => "₲ " + Number(n || 0).toLocaleString("es-PY");

export const waLink = (message) =>
  `https://wa.me/${STORE.whatsapp}?text=${encodeURIComponent(message)}`;
